import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useSectorizationChartsDataContext } from './hooks/useSectorizationChartsDataContext';

export const SectorizationByNeighborhoodMonthly = () => {
    const { chartData } = useSectorizationChartsDataContext();

    return (
        <SimpleBars
            title={'Resultado das ocorrências mensais por região'}
            horizontal={false}
            subtitles={chartData?.sectorizationByNeighborhoodMonthly?.categories}
            series={chartData?.sectorizationByNeighborhoodMonthly?.series}
        />
    );
};